import { css as _css } from "@emotion/react";
function cov_az3g2y7x3() {
  var path = "/__w/code/code/js/packages/cinderblocks/src/buy/Toggle/Toggle.tsx";
  var hash = "58dcf6334c80dface8f84955ba8cb1c2ed3c3a92";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/cinderblocks/src/buy/Toggle/Toggle.tsx",
    statementMap: {
      "0": {
        start: {
          line: 20,
          column: 46
        },
        end: {
          line: 112,
          column: 1
        }
      },
      "1": {
        start: {
          line: 29,
          column: 40
        },
        end: {
          line: 29,
          column: 96
        }
      },
      "2": {
        start: {
          line: 31,
          column: 19
        },
        end: {
          line: 34,
          column: 3
        }
      },
      "3": {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 32,
          column: 70
        }
      },
      "4": {
        start: {
          line: 33,
          column: 4
        },
        end: {
          line: 33,
          column: 64
        }
      },
      "5": {
        start: {
          line: 36,
          column: 2
        },
        end: {
          line: 111,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 20,
            column: 46
          },
          end: {
            line: 20,
            column: 47
          }
        },
        loc: {
          start: {
            line: 28,
            column: 6
          },
          end: {
            line: 112,
            column: 1
          }
        },
        line: 28
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 31,
            column: 19
          },
          end: {
            line: 31,
            column: 20
          }
        },
        loc: {
          start: {
            line: 31,
            column: 25
          },
          end: {
            line: 34,
            column: 3
          }
        },
        line: 31
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 27,
            column: 2
          },
          end: {
            line: 27,
            column: 15
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 27,
            column: 9
          },
          end: {
            line: 27,
            column: 15
          }
        }],
        line: 27
      },
      "1": {
        loc: {
          start: {
            line: 32,
            column: 19
          },
          end: {
            line: 32,
            column: 68
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 32,
            column: 47
          },
          end: {
            line: 32,
            column: 56
          }
        }, {
          start: {
            line: 32,
            column: 59
          },
          end: {
            line: 32,
            column: 68
          }
        }],
        line: 32
      },
      "2": {
        loc: {
          start: {
            line: 33,
            column: 13
          },
          end: {
            line: 33,
            column: 62
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 33,
            column: 41
          },
          end: {
            line: 33,
            column: 50
          }
        }, {
          start: {
            line: 33,
            column: 53
          },
          end: {
            line: 33,
            column: 62
          }
        }],
        line: 33
      },
      "3": {
        loc: {
          start: {
            line: 50,
            column: 19
          },
          end: {
            line: 50,
            column: 68
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 50,
            column: 47
          },
          end: {
            line: 50,
            column: 55
          }
        }, {
          start: {
            line: 50,
            column: 58
          },
          end: {
            line: 50,
            column: 68
          }
        }],
        line: 50
      },
      "4": {
        loc: {
          start: {
            line: 71,
            column: 27
          },
          end: {
            line: 71,
            column: 81
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 71,
            column: 55
          },
          end: {
            line: 71,
            column: 66
          }
        }, {
          start: {
            line: 71,
            column: 69
          },
          end: {
            line: 71,
            column: 81
          }
        }],
        line: 71
      },
      "5": {
        loc: {
          start: {
            line: 79,
            column: 29
          },
          end: {
            line: 79,
            column: 83
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 79,
            column: 57
          },
          end: {
            line: 79,
            column: 68
          }
        }, {
          start: {
            line: 79,
            column: 71
          },
          end: {
            line: 79,
            column: 83
          }
        }],
        line: 79
      },
      "6": {
        loc: {
          start: {
            line: 82,
            column: 23
          },
          end: {
            line: 82,
            column: 62
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 82,
            column: 34
          },
          end: {
            line: 82,
            column: 46
          }
        }, {
          start: {
            line: 82,
            column: 49
          },
          end: {
            line: 82,
            column: 62
          }
        }],
        line: 82
      },
      "7": {
        loc: {
          start: {
            line: 89,
            column: 27
          },
          end: {
            line: 89,
            column: 81
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 89,
            column: 55
          },
          end: {
            line: 89,
            column: 66
          }
        }, {
          start: {
            line: 89,
            column: 69
          },
          end: {
            line: 89,
            column: 81
          }
        }],
        line: 89
      },
      "8": {
        loc: {
          start: {
            line: 97,
            column: 29
          },
          end: {
            line: 97,
            column: 83
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 97,
            column: 57
          },
          end: {
            line: 97,
            column: 68
          }
        }, {
          start: {
            line: 97,
            column: 71
          },
          end: {
            line: 97,
            column: 83
          }
        }],
        line: 97
      },
      "9": {
        loc: {
          start: {
            line: 100,
            column: 23
          },
          end: {
            line: 100,
            column: 62
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 100,
            column: 34
          },
          end: {
            line: 100,
            column: 46
          }
        }, {
          start: {
            line: 100,
            column: 49
          },
          end: {
            line: 100,
            column: 62
          }
        }],
        line: 100
      },
      "10": {
        loc: {
          start: {
            line: 105,
            column: 53
          },
          end: {
            line: 105,
            column: 81
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 105,
            column: 65
          },
          end: {
            line: 105,
            column: 71
          }
        }, {
          start: {
            line: 105,
            column: 74
          },
          end: {
            line: 105,
            column: 81
          }
        }],
        line: 105
      },
      "11": {
        loc: {
          start: {
            line: 106,
            column: 21
          },
          end: {
            line: 106,
            column: 60
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 106,
            column: 32
          },
          end: {
            line: 106,
            column: 44
          }
        }, {
          start: {
            line: 106,
            column: 47
          },
          end: {
            line: 106,
            column: 60
          }
        }],
        line: 106
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "58dcf6334c80dface8f84955ba8cb1c2ed3c3a92"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_az3g2y7x3 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_az3g2y7x3();
import React, { useState } from 'react';

// eslint-disable-next-line no-restricted-imports
import { Box, Button, Flex, Label, Text } from '@opendoor/bricks/core';
/**
 * ARIA friendly Toggle implementation
 * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/switch_role
 */
cov_az3g2y7x3().s[0]++;
export const Toggle = _ref => {
  let {
    disabled,
    hideLabel,
    label,
    optionOne,
    optionTwo,
    onChange,
    size = (cov_az3g2y7x3().b[0][0]++, '40px')
  } = _ref;
  cov_az3g2y7x3().f[0]++;
  const [activeLabel, setActiveLabel] = (cov_az3g2y7x3().s[1]++, useState(optionOne));
  cov_az3g2y7x3().s[2]++;
  const onToggle = () => {
    cov_az3g2y7x3().f[1]++;
    cov_az3g2y7x3().s[3]++;
    setActiveLabel(activeLabel === optionOne ? (cov_az3g2y7x3().b[1][0]++, optionTwo) : (cov_az3g2y7x3().b[1][1]++, optionOne));
    cov_az3g2y7x3().s[4]++;
    onChange(activeLabel === optionOne ? (cov_az3g2y7x3().b[2][0]++, optionTwo) : (cov_az3g2y7x3().b[2][1]++, optionOne));
  };
  cov_az3g2y7x3().s[5]++;
  return /*#__PURE__*/React.createElement(Flex, {
    borderColor: "neutrals30",
    borderRadius: "roundedSmooth",
    className: "switch",
    flexDirection: "column",
    height: size,
    mx: 4
  }, /*#__PURE__*/React.createElement(Button, {
    analyticsName: "toggle",
    "aria-checked": activeLabel === optionOne,
    "aria-label": "toggle-active-".concat(activeLabel),
    backgroundColor: "neutrals30",
    className: activeLabel === optionOne ? (cov_az3g2y7x3().b[3][0]++, 'active') : (cov_az3g2y7x3().b[3][1]++, 'inactive'),
    disabled: disabled,
    id: "toggle",
    variant: "ghost",
    role: "switch",
    width: "fit-content",
    type: "button",
    _hover: {
      backgroundColor: 'neutrals30'
    },
    style: {
      borderRadius: '24px' // roundedSmooth, but the token doesn't work
    },
    borderColor: "neutrals30",
    borderStyle: "solid",
    borderWidth: "3px",
    onClick: onToggle
  }, /*#__PURE__*/React.createElement(Box, {
    as: "span",
    alignItems: "center",
    backgroundColor: activeLabel === optionOne ? (cov_az3g2y7x3().b[4][0]++, 'neutrals0') : (cov_az3g2y7x3().b[4][1]++, 'neutrals30'),
    borderRadius: "roundedSmooth",
    display: "flex",
    height: size,
    id: "toggle-".concat(optionOne),
    justifyContent: "center",
    width: size,
    _hover: {
      backgroundColor: activeLabel === optionOne ? (cov_az3g2y7x3().b[5][0]++, 'neutrals0') : (cov_az3g2y7x3().b[5][1]++, 'neutrals30')
    }
  }, /*#__PURE__*/React.createElement(Text, {
    color: disabled ? (cov_az3g2y7x3().b[6][0]++, 'neutrals70') : (cov_az3g2y7x3().b[6][1]++, 'neutrals100'),
    fontWeight: "semibold"
  }, optionOne)), /*#__PURE__*/React.createElement(Box, {
    as: "span",
    alignItems: "center",
    backgroundColor: activeLabel === optionTwo ? (cov_az3g2y7x3().b[7][0]++, 'neutrals0') : (cov_az3g2y7x3().b[7][1]++, 'neutrals30'),
    borderRadius: "roundedSmooth",
    display: "flex",
    height: size,
    id: "toggle-".concat(optionTwo),
    justifyContent: "center",
    width: size,
    _hover: {
      backgroundColor: activeLabel === optionTwo ? (cov_az3g2y7x3().b[8][0]++, 'neutrals0') : (cov_az3g2y7x3().b[8][1]++, 'neutrals30')
    }
  }, /*#__PURE__*/React.createElement(Text, {
    color: disabled ? (cov_az3g2y7x3().b[9][0]++, 'neutrals70') : (cov_az3g2y7x3().b[9][1]++, 'neutrals100'),
    fontWeight: "semibold"
  }, optionTwo))), /*#__PURE__*/React.createElement(Label, {
    htmlFor: "toggle",
    mt: 2,
    css: /*#__PURE__*/_css({
      display: hideLabel ? (cov_az3g2y7x3().b[10][0]++, 'none') : (cov_az3g2y7x3().b[10][1]++, 'block')
    }, process.env.NODE_ENV === "production" ? "" : ";label:Toggle;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  }, /*#__PURE__*/React.createElement(Text, {
    color: disabled ? (cov_az3g2y7x3().b[11][0]++, 'neutrals70') : (cov_az3g2y7x3().b[11][1]++, 'neutrals100'),
    fontWeight: "semibold"
  }, label)));
};
//# sourceMappingURL=Toggle.mjs.map